module.exports = __webpack_public_path__ + "static/img/LOGO15.48d2d0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/LOGO15.png
// module id = 22ar
// module chunks = 0